import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnderecoComponent } from 'app/resources/componentes/endereco/endereco.component';
import { FormsModule } from '@angular/forms';
import { BodyModule } from 'app/body/body.module';
import { UiCepDirective } from 'app/resources/diretives/ui-cep.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    EnderecoComponent,
    UiCepDirective
  ],
  exports: [
    EnderecoComponent,
    UiCepDirective
  ]

})
export class ComponentesModule { }



// WEBPACK FOOTER //
// ./src/app/resources/componentes/componentes.module.ts